import {Loader} from 'google-maps';

export default function() {
  let map_api_key = typeof tofinoJS.map_api_key !== "undefined" ? tofinoJS.map_api_key : 'AIzaSyAMViHixyJPcDTmPdN7_ODOWQEgROryTaA'
  const $maps = document.getElementsByClassName('acf-map')

  if($maps.length) {
    const loader = new Loader(map_api_key);
    let map,lat, lng, latLng;

    Array.from($maps).forEach(
      function(element, i) {
        loader.load().then(function (google) {
          let locations = element.dataset.locations ? JSON.parse(element.dataset.locations) : [];
          if((!locations || !locations.length) && element.dataset.lat && element.dataset.lng ) {
            locations = [
              {
                lat: element.dataset.lat,
                lng: element.dataset.lng,
                zoom: element.dataset.zoom,
                address: ''
              }
            ];
          }
          let parsedLocations = [];
          locations.forEach((loc) => {
            if (loc.lat && loc.lng) {
              parsedLocations.push({
                lat: parseFloat(loc.lat),
                lng: parseFloat(loc.lng),
                zoom: parseInt(loc.zoom, 10),
                address: loc.address || ''
              });
            }
          });

          map = new google.maps.Map(element, {
            center: {lat: parsedLocations[0].lat, lng: parsedLocations[0].lng},
            zoom: parsedLocations[0].zoom
          });
          const infoWindow = new google.maps.InfoWindow();
          const bounds = new google.maps.LatLngBounds();
          let openMarker = null;
          const markers = [];
          const pathCoordinates = [];
          parsedLocations.forEach((loc) => {
            const position = new google.maps.LatLng(loc.lat, loc.lng);
            const marker = new google.maps.Marker({
              position: position,
              map: map,
              animation: google.maps.Animation.DROP
            })
            pathCoordinates.push({ lat: loc.lat, lng: loc.lng });
            bounds.extend(position);
            markers.push(marker);
            marker.addListener("click", () => {
              if (openMarker === marker) {
                // Close if same marker clicked again
                infoWindow.close();
                openMarker = null;
              } else {
                infoWindow.setContent(`<div class="wtg-map-info-box">${loc.address}</div>`);
                infoWindow.open(map, marker);
                openMarker = marker;
              }
            });
          });
          if(pathCoordinates.length > 1) {
            const polyline = new google.maps.Polyline({
              path: pathCoordinates,
              geodesic: true,
              strokeOpacity: .5,
              strokeWeight: 3,
              icons: [
                {
                  icon: {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    scale: 3,
                    strokeWeight: 2,
                  },
                  offset: '100%', // Arrow at the end of the line
                  repeat: "100px",
                }
              ]
            });

            // Add the polyline to the map
            polyline.setMap(map);
          }
          google.maps.event.addListenerOnce(map, 'idle', () => {
            const currentBounds = map.getBounds();
            let anyOutOfView = false;

            currentBounds && markers.forEach(({ position }) => {
              if (!currentBounds.contains(position)) {
                anyOutOfView = true;
              }
            });

            if (anyOutOfView) {
              map.fitBounds(bounds);
            }
          });
        })
      }
    )
  }
}
